import * as Actions from 'reducks/basket/actions'
import { initialState } from 'reducks/reduxStore/initialState'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BasketReducer = (state = initialState.basket, action: any) => {
  switch (action.type) {
    case Actions.FETCH_BASKETS:
      return {
        ...state,
        baskets: [...action.payload],
      }
    case Actions.INIT_BASKETS:
      return {
        baskets: [],
        is_set_unsubscribe: false,
        unsubscribes: [],
      }
    case Actions.INIT_BASKET_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: false,
        unsubscribes: [],
      }
    case Actions.SET_BASKET_UNSUBSCRIBES:
      return {
        ...state,
        is_set_unsubscribe: true,
        unsubscribes: [...action.payload],
      }
    default:
      return state
  }
}
